"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGAUserProperties = exports.sendGAEvent = exports.checkGtag = void 0;

var checkGtag = function checkGtag() {
  //check if gtag is defined if not then console.log the error
  var gtag = window.gtag;

  if (gtag) {
    return true;
  } else {
    console.error("window.gtag is not defined");
    return false;
  }
};

exports.checkGtag = checkGtag;
/**
 *
 * @param eventName event name
 * @param eventParams event parameters. This is a generic type <T> which can be any type of object that represents the parameters for the event.
 */

var sendGAEvent = function sendGAEvent(eventName) {
  var eventParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // @ts-ignore
  (0, exports.checkGtag)() && window.gtag("event", eventName, eventParams);
};

exports.sendGAEvent = sendGAEvent;
/**
 *
 * @param userProperties Properties to describe the user in Google Analytics
 */

var setGAUserProperties = function setGAUserProperties(userProperties) {
  // @ts-ignore
  (0, exports.checkGtag)() && window.gtag("set", "user_properties", userProperties);
};

exports.setGAUserProperties = setGAUserProperties;
var AnalyticsUtilities = {
  sendGAEvent: exports.sendGAEvent,
  setGAUserProperties: exports.setGAUserProperties
};
exports.default = AnalyticsUtilities;